import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { Button, Spinner, Text, useColorMode } from "theme-ui";

export const DeletePopModule = ({ setIsDeleteModelOpen, updatedDataFun, isDeleteModelOpen, message }: any) => {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const confirmDelete = async () => {
    if (isDeleting) return;
    try {
      setIsDeleting(true);
      await Promise.resolve(updatedDataFun());
    } catch (e) {
      // ignore error
    } finally {
      setIsDeleting(false);
      setIsDeleteModelOpen(false);
    }
  };

  const cancelDelete = () => {
    if (isDeleting) return;
    setIsDeleteModelOpen(false);
  };

  const [colorMode] = useColorMode();
  const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
  const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

  return (
    <Modal isOpen={isDeleteModelOpen} toggle={cancelDelete} centered className='w-100'>
      <ModalBody className='mb-0 pb-0' style={{ backgroundColor: modalHeader }}>
        <div style={{
          width: '100%',
          position: 'relative',
          zIndex: 1,
          backgroundColor: modalHeader,
          border: '1px solid #black',
          boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06);',
          borderRadius: '4px',
          padding: '20px 4px',
          textAlign: "center"
        }}>
          <Text className=" w-100" as="p" sx={{ color: titleHeader }} >
            <strong>{message}</strong>
          </Text>
        </div>
      </ModalBody>
      <ModalBody className='d-flex' style={{ backgroundColor: modalHeader }}>
        <Button onClick={confirmDelete} disabled={isDeleting} sx={{ marginRight: '10px', width: '50%', cursor: isDeleting ? 'not-allowed' : 'pointer' }}>
          {isDeleting ? <Spinner size={16} sx={{ color: '#fff' }} /> : 'Yes'}
        </Button>
        <Button onClick={cancelDelete} disabled={isDeleting} sx={{ width: '50%', cursor: isDeleting ? 'not-allowed' : 'pointer' }}>No</Button>
      </ModalBody>
    </Modal >
  )
}
